import { featuredTools } from "@/data/featuredTools";
import { categories } from "@/data/categories";
import Navbar from "@/components/Navbar";
import Carousel from "@/components/Carousel";
import CategoryPreview from "@/components/CategoryPreview";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <div className="container mx-auto px-4 py-8">
          <Carousel tools={featuredTools} />
          <CategoryPreview categories={categories} />
        </div>
      </main>
      <Footer />
    </div>
  );
}